import React, { Component, useRef } from 'react';
import {Table, Button, Modal, Descriptions, List, Empty, Spin} from "antd";
import consts from "../../consts";
import utils from "../../common/utils";
import { Translation } from "react-i18next";
import SimpleDataTable from "../common/SimpleDataTable";
import BigNumber from "bignumber.js";
import LoadingSvg from "../common/LoadingSvg";
import { debounce, remove, map, omit } from 'lodash';
import { CloseOutlined, LoadingOutlined  } from '@ant-design/icons';
import {unix} from "moment";


class OpenOrder extends Component {
	columns = (t) => [
		{
			title: t('user.open_order_exchange.deposit_history'),
			width: 50,
			dataIndex: 'order_type',
			key: 'order_type',
			headerStyle: {
				paddingLeft: 8,
			},
			justRender: true,
			render: (order_type, openOrder, maxWidth) => {
				return <div
					title={t(order_type)}
					style={{
						color: (openOrder.trade_type === consts.ORDER_TRADE_TYPE_BUY) ? 'green' : 'red',
						width: `${50 / maxWidth * 100}%`,
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						overflow: 'hidden',
						margin: 'auto',
						paddingLeft: 8,
						marginRight: 5,
					}}>
					{t(order_type)}
				</div>
			}
		},
		{
			title: t('user.open_order_exchange.deposits'),
			width: 80,
			dataIndex: 'pair',
			key: 'pair',
			style: {
				margin: 'auto',
			},
			headerStyle: {
				paddingLeft: 6,
			},
		},
		{
			title: t('user.open_order_exchange.withdrawal'),
			width: 60,
			dataIndex: 'price',
			key: 'price',
			style: {
				margin: 'auto',
			},
			headerStyle: {
				paddingLeft: 5,
			},
			render: (price, order) => order.type == consts.ORDER_TYPE_MARKET ? t('exchange.right_panel.market') : utils.specialFormatJsx(price),
		},
		{
			title: '',
			dataIndex: '',
			width: 60,
			headerStyle: {
				paddingLeft: 0,
			},
			render: (id, item) => <Button onClick={() => this.showModal(item)} type="default" style={{ marginTop: 5 }}>
				<div style={{ lineHeight: '100%', fontWeight: 500 }}>
					<i className='icon-cancel-circle red' />
				</div>
			</Button>
		}
	];

	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			currentPage: 1,
			loadings: [],
		};
		// this.hideModal = this.hideModal.bind(this);
		this.handleCancelOrder = this.handleCancelOrder.bind(this);
		// this.showModal = this.showModal.bind(this);
	}

	componentDidMount() {
		this.props.onFetchOpenOrderAction({
			pos: 0,
			count: consts.DEFAULT_PAGE_SIZE,
		});
	}


	handleCancelOrder = debounce(( order_id) => {
		const {loadings} = this.state
		this.setState({
			loadings: {...loadings, [order_id]: true}
		})
		this.props.onCancelOrderExchangeAction({ order_id }, () => {
			this.setState({
				currentPage: 1,
				isLoading: false,
				loadings: {...loadings, [order_id]: false}
			});
		})
	}, 400);


	setValueOrderOpen = (item) => {
		if (item.trade_type === consts.ORDER_TRADE_TYPE_BUY) {
			this.props.onClickOrderBookBuy({
				price: item.price,
				quantity: item.quantity,
				total: new BigNumber(item.price).times(item.quantity).toFixed(2),
			});
			this.props.orderClick('Buy');
		} else if (item.trade_type === consts.ORDER_TRADE_TYPE_SELL) {
			this.props.onClickOrderBookSell({
				price: item.price,
				quantity: item.quantity,
				total: new BigNumber(item.price).times(item.quantity).toFixed(2),
			});
			this.props.orderClick('Sell');
		}
	}


	render() {
		return (
			<Translation>
				{(t) => <div className="deposit-exchange-wrap fz-medium" >
					<div>
						<div className='d-flex align-items space-between tabs-custom'>
							<div>{t('exchange.right_panel.market')}</div>
							<div>{t("pending.order")}</div>
						</div>
						<List
							itemLayout="horizontal"
							locale={{emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>} />)}}
							dataSource={[...this.props.order.openOrders || []]}
							style={{
								background:"#36393D",
								height: "100%",
								overflowY: 'auto',
								paddingBottom: 48,
							}}
							renderItem={(item, index) => {
								return (
									<List.Item 
									className="pointer"
									style={{
										color:'#76808F',
										borderLeft: `3px solid  ${(item.trade_type === consts.ORDER_TRADE_TYPE_BUY) ? '#147724' : '#DF4249'}` ,
									}} key={item.pair}
										onClick={() => this.setValueOrderOpen(item)}
										>
										<List.Item.Meta
											description={(
												<div className='d-flex w.100 align-items space-between pl-small pr-small'>
													<div className='text-small text-grey ' >
														<div className='d-flex'>
															<div className="ellipsis mr-small bold">
																{item.pair}
															</div>
															<div className="ellipsis">
																<span className="text-white bold">{utils.specialFormatJsx(item.quantity)}</span>
																	/
																<span style={{color: (item.trade_type === consts.ORDER_TRADE_TYPE_BUY) ? '#147724' : '#DF4249'}} className="bold">
																{utils.specialFormatJsx(item.price)}
																</span>
															</div>
														</div>
														<div className='d-flex'>
															<div>
																{/*{t('Stop Limit')}*/}
																<span>{t(item.order_type)}</span>
															</div>
															<div
																style={{
																	color: (item.trade_type === consts.ORDER_TRADE_TYPE_BUY) ? '#147724' : '#DF4249',
																	// width: `${50 / maxWidth * 100}%`,
																	whiteSpace: 'nowrap',
																	textOverflow: 'ellipsis',
																	overflow: 'hidden',
																}}>
																	<span style={{
																			height: 3,
																			width: 3,
																			display: 'inline-block',
																			background: '#76808F',
																			margin: "0px 3px 3px",
																			borderRadius:"50%",
																		}}
																	/>
																	<span>{t(item.tradeType)}</span>
																	<span style={{
																			height: 6,
																			width: 6,
																			display: 'inline-block',
																			background: (item.trade_type === consts.ORDER_TRADE_TYPE_BUY) ? '#147724' : '#DF4249',
																			borderRadius:"50%",
																			margin: "0px 4px 1px"
																		}}
																	/>
																	<span className="text-white bold">{utils.specialFormatJsx(item.total)}</span>
															</div>
														</div>
													</div>
													<div className="ellipsis item-created-at">
													{ this.state.loadings[item.id] ? 
														<div style={{marginRight: 15}}>
															<Spin 
																indicator={<LoadingOutlined style={{ fontSize: 24, color: '#fff' }} />} 
															/> 
														</div>
														:
														<Button
															onClick={(event) => {
																event.stopPropagation(); 
																this.handleCancelOrder(item.id)
															}}
															style={{
																background: 'none',
																border:"none",
																color:"#76808F",
																padding: 0,
															}}
														>
															<div style={{ lineHeight: '100%', fontWeight: 500, background: 'none' }}>		
																<CloseOutlined style={{ fontSize: 18 }} />	
															</div>
															<div style={{ fontSize: 10 }}>
																{ unix(item.created_at).fromNow() }
															</div>
														</Button>
													}
													</div>
												</div>
											)}
										/>
									</List.Item>
								)
							}}
						/>
						</div>
				</div>}
			</Translation>
		);
	}
}

export default OpenOrder;
